import { ActionType, createReducer } from 'typesafe-actions';
import {
  addedMessageStore,
  addNewMessageInput,
  setIsBlockedChat,
  setIsSendButtonBlocked,
  setLoadingSendMessage,
  setIsChatInputFocused,
} from './actions';
import { IChatPanelState } from './types';
import moment from 'moment';

export const settingsPanelState: IChatPanelState = {
  messages: [],
  messageError: null,
  newMessage: null,
  isBlockedChat: false,
  isSendButtonBlocked: false,
  lastSentMessages: [],
  loadingSendMessage: false,
  isChatInputFocused: false,
};

const actions = {
  addedMessageStore,
  addNewMessageInput,
  setIsBlockedChat,
  setIsSendButtonBlocked,
  setLoadingSendMessage,
  setIsChatInputFocused,
};

export const chatPanelReducer = createReducer<IChatPanelState, ActionType<typeof actions>>(
  settingsPanelState,
)
  .handleAction(addedMessageStore, (state, { payload: message }) => ({
    ...state,
    messages: [...state.messages.slice(-49), { ...message, addedAt: moment().toISOString() }],
    lastSentMessages: [...state.lastSentMessages, Date.now()].slice(-10),
  }))
  .handleAction(addNewMessageInput, (state, { payload: newMessage }) => ({
    ...state,
    newMessage,
  }))
  .handleAction(setIsBlockedChat, (state, { payload: isBlockedChat }) => ({
    ...state,
    isBlockedChat,
  }))
  .handleAction(setIsSendButtonBlocked, (state, { payload: isSendButtonBlocked }) => ({
    ...state,
    isSendButtonBlocked,
  }))
  .handleAction(setLoadingSendMessage, (state, { payload: loadingSendMessage }) => ({
    ...state,
    loadingSendMessage,
  }))
  .handleAction(setIsChatInputFocused, (state, { payload: isChatInputFocused }) => ({
    ...state,
    isChatInputFocused,
  }));
